import type { PlanKind, PlanRun } from '@cockpit/shared';
import { usePlanStore, type PlanOpenOptions } from '../stores/plan';

/**
 * Point d'entrée des écrans : `openPlan(kind, refs)` ouvre l'écran de validation (monté une fois dans
 * la coquille) ; `runDirect(kind, refs)` exécute aussitôt un plan d'une seule étape (action directe). Lot BI : les
 * deux laissent 5 secondes pour « Annuler » ; la promesse se résout avec l'exécution réelle (null si annulé), et
 * `options.onScheduled` prévient l'écran dès la validation (carte cachée tout de suite).
 */
export function usePlan(): {
  openPlan: (
    kind: PlanKind,
    refs?: Record<string, unknown>,
    options?: PlanOpenOptions,
  ) => Promise<PlanRun | null>;
  runDirect: (
    kind: PlanKind,
    refs?: Record<string, unknown>,
    options?: PlanOpenOptions,
  ) => Promise<PlanRun | null>;
} {
  const store = usePlanStore();
  return { openPlan: store.openPlan, runDirect: store.runDirect };
}
